var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinRacingResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/Racing/Results") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2261754,2.81867267 L28.4861808,2.81867267 L28.4861808,2.87314354 C28.4861808,5.55194281 26.7435112,7.84814912 24.2148404,8.77674765",
    id: "Stroke-1",
    stroke: "#FDC600",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9240932,8.77707189 C13.3954223,7.84782488 11.6527528,5.55161858 11.6527528,2.87346777 L11.6527528,2.8189969 L14.9120915,2.8189969",
    id: "Stroke-3",
    stroke: "#FDC600",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3007105,0 L20.3033672,0 L19.8346997,0 L13.8380231,0 L13.8380231,1.945388 C13.8380231,1.945388 13.6526894,8.31329139 16.2380271,10.5057437 C17.6526961,11.5556047 17.7986963,11.6736249 18.798698,11.906423 L18.798698,13.8135517 C18.798698,15.0592485 17.7586963,16.109758 16.4386941,16.109758 L16.4386941,17.5882529 L19.8346997,17.5882529 L20.3033672,17.5882529 L23.7000395,17.5882529 L23.7000395,16.109758 C22.380704,16.109758 21.3400356,15.0592485 21.3400356,13.8135517 L21.3400356,11.906423 C22.3400372,11.6736249 22.4860375,11.5556047 23.9000398,10.5057437 C26.4860441,8.31329139 26.3007105,1.945388 26.3007105,1.945388 L26.3007105,0 Z",
    id: "Fill-5",
    fill: "#FDC600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0000667,31.0938507 C40.0000667,32.5263047 31.0460517,33.6877013 20.0000333,33.6877013 C8.95468159,33.6877013 0,32.5263047 0,31.0938507 C0,29.6613966 8.95468159,28.5 20.0000333,28.5 C31.0460517,28.5 40.0000667,29.6613966 40.0000667,31.0938507",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5230242,31.3909105 L3.56900595,31.3909105 L3.56900595,22.2209999 C3.56900595,21.5692949 4.11634019,21.0369071 4.78634131,21.0369071 L13.3056888,21.0369071 C13.9750233,21.0369071 14.5230242,21.5692949 14.5230242,22.2209999 L14.5230242,31.3909105 Z",
    id: "Fill-10",
    fill: "#21A4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4771758,31.3909105 L14.5231575,31.3909105 L14.5231575,18.7231923 C14.5231575,18.0721357 15.0704918,17.5397479 15.7404929,17.5397479 L24.2598404,17.5397479 C24.9291749,17.5397479 25.4771758,18.0721357 25.4771758,18.7231923 L25.4771758,31.3909105 Z",
    id: "Fill-12",
    fill: "#3988C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4312607,31.3909105 L25.4772425,31.3909105 L25.4772425,25.4172724 C25.4772425,24.7662159 26.0245767,24.233828 26.6945778,24.233828 L35.2139254,24.233828 C35.8832598,24.233828 36.4312607,24.7662159 36.4312607,25.4172724 L36.4312607,31.3909105 Z",
    id: "Fill-14",
    fill: "#122C68"
  })), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "NotoSansCJKtc-Black, Noto Sans CJK TC",
    fontSize: 6,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 18.173,
    y: 24.3043862
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: 2,
    fontFamily: "NotoSansCJKtc-Black, Noto Sans CJK TC",
    fontSize: 6,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.173,
    y: 27.5454027
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: 3,
    fontFamily: "NotoSansCJKtc-Black, Noto Sans CJK TC",
    fontSize: 6,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 29.173,
    y: 30.1405502
  }, "3")), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(14.500000, 0.680397)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0.5,
    x2: 11,
    y2: 0.5,
    id: "Stroke-17",
    stroke: "#E2A528",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11.8480967,
    x2: 6,
    y2: 11.8480967,
    id: "Stroke-19",
    stroke: "#E2A528",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 15.7388727,
    x2: 8,
    y2: 15.7388727,
    id: "Stroke-21",
    stroke: "#E2A528",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92049737,3.91649041 C4.28449797,3.87498879 4.71249869,3.57799289 4.87183229,3.25570695 L5.21116619,2.57093037 C5.36983312,2.24994135 5.62983355,2.24994135 5.78916715,2.57093037 L6.12850105,3.25570695 C6.28716798,3.57799289 6.71516869,3.87952803 7.07850263,3.92751427 L7.83917057,4.02802598 C8.2025045,4.07601222 8.28250464,4.31594341 8.01783753,4.56235922 L7.46450327,5.07529319 C7.1991695,5.32106054 7.03716923,5.80935293 7.10450267,6.16017123 L7.24850291,6.91044254 C7.31583636,7.26126084 7.10716935,7.4078134 6.78583548,7.23661926 L6.08516764,6.86375323 C5.76316711,6.69255908 5.23449956,6.68866831 4.91049902,6.85532321 L4.21916453,7.21068075 C3.89449732,7.37733566 3.68449697,7.22624386 3.75183042,6.87607402 L3.89516399,6.12580271 C3.96249744,5.77498441 3.80049717,5.28669202 3.53516339,5.04027621 L2.9824958,4.5279907 C2.71716203,4.28157489 2.79782883,4.04618294 3.16182944,4.00468133 L3.92049737,3.91649041 Z",
    id: "Fill-23",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinRacingResults);
export default __webpack_public_path__ + "static/media/ewin_racing-results.a572642151e18230e4da055ff54c3264.svg";
export { ForwardRef as ReactComponent };